import service from '@/utils/request'

export const getCourseIntroduce = (params:any) => {
  return service({
    url: '/srv/user/study/getCourseIntroduce',
    method: 'get',
    params
  })
}